/**
 * Admin Onboarding Service
 * TASK-339: Onboarding Wizard UI
 *
 * API client for the admin onboarding wizard endpoints.
 */

import { httpClient } from '../lib/httpClient';
import {
  TokenValidateResponse,
  SetPasswordRequest,
  SetPasswordResponse,
  FirmInfoRequest,
  FirmInfoResponse,
  SecuritySettingsRequest,
  SecuritySettingsResponse,
  TeamInviteRequest,
  TeamInviteResponse,
  CompleteOnboardingRequest,
  CompleteOnboardingResponse,
} from '../types/adminOnboarding';

const API_PREFIX = '/api/onboarding';

/**
 * Admin Onboarding Service
 */
export const adminOnboardingService = {
  /**
   * Validate onboarding token and get account info
   */
  async validateToken(token: string): Promise<TokenValidateResponse> {
    return httpClient.get<TokenValidateResponse>(
      `${API_PREFIX}/validate?token=${encodeURIComponent(token)}`
    );
  },

  /**
   * Step 1: Set password for admin account
   */
  async setPassword(request: SetPasswordRequest): Promise<SetPasswordResponse> {
    return httpClient.post<SetPasswordResponse>(
      `${API_PREFIX}/password`,
      request
    );
  },

  /**
   * Step 2: Save firm information
   */
  async saveFirmInfo(request: FirmInfoRequest): Promise<FirmInfoResponse> {
    return httpClient.put<FirmInfoResponse>(
      `${API_PREFIX}/firm-info`,
      request
    );
  },

  /**
   * Step 3: Configure security settings
   */
  async saveSecuritySettings(request: SecuritySettingsRequest): Promise<SecuritySettingsResponse> {
    return httpClient.put<SecuritySettingsResponse>(
      `${API_PREFIX}/security`,
      request
    );
  },

  /**
   * Step 4: Send team invitations
   */
  async sendTeamInvitations(request: TeamInviteRequest): Promise<TeamInviteResponse> {
    return httpClient.post<TeamInviteResponse>(
      `${API_PREFIX}/invite`,
      request
    );
  },

  /**
   * Complete onboarding and get JWT token
   */
  async completeOnboarding(request: CompleteOnboardingRequest): Promise<CompleteOnboardingResponse> {
    return httpClient.post<CompleteOnboardingResponse>(
      `${API_PREFIX}/complete`,
      request
    );
  },
};

export default adminOnboardingService;
